import { CogNeedTextField } from '@cogneed/react-utils';
import { TOGGLE_LINK_COMMAND } from '@lexical/link';
import CheckMarkIcon from '@mui/icons-material/CheckRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button } from '@mui/material';
import { LexicalEditor } from 'lexical';
import React from 'react';
import { sanitizeUrl } from '../../../../../utils/url';
import StyledBox from './styles';

interface FloatingLinkEditProps {
  initUrl: string;
  stopEditing: () => void;
  editor: LexicalEditor;
}

export default function FloatingLinkEdit(props: FloatingLinkEditProps) {
  const { initUrl, stopEditing, editor } = props;
  const [buffer, setBuffer] = React.useState(initUrl);

  React.useEffect(() => {
    setBuffer(initUrl);
  }, [initUrl]);

  const handleLinkSubmission = () => {
    if (buffer !== '') {
      editor.dispatchCommand(TOGGLE_LINK_COMMAND, sanitizeUrl(buffer));
    }
    stopEditing();
  };

  const monitorInputInteraction = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleLinkSubmission();
    } else if (event.key === 'Escape') {
      event.preventDefault();
      stopEditing();
    }
  };

  return (
    <StyledBox>
      <CogNeedTextField
        InputProps={{
          onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
            monitorInputInteraction(event);
          },
        }}
        value={buffer}
        onChange={(event) => {
          setBuffer(event.target.value);
        }}
        autoFocus
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleLinkSubmission}
      >
        <CheckMarkIcon />
      </Button>
      <Button
        variant="outlined"
        color="info"
        onClick={() => {
          stopEditing();
        }}
      >
        <CloseIcon />
      </Button>
    </StyledBox>
  );
}
